export default {
  'searchVisitor':	'Please enter key words to search for visitors',
  'searchProduct': 'Please enter key words to search for exhibits',
  'searchActor': 'Please enter key words to search for exhibitors',
  'myWorker': 'My Account  ',
  'myIsActor': 'I am exhibitor',
  'myIsVisitor': 'I am Guest',
  'common': 'Total',
  'condition': '',
  'cancel': 'Cancel',
  'sure': 'Confirm',
  'wantToSee': 'Maybe interested',
  'businessCircle': 'Biz Hub',
  'collectionS': 'Interested',
  'collectionF': 'Cancel',
  'inviteSuccess': 'Invitation sent',
  'invited': 'Added',
  'employeeeManage': "Employee management",
  'preferredExhibits': 'Hot',
  'enterDetail': 'Click for more details',
  'contcatUs': 'Contact us',
  'hotProduct': 'Popular products',
  'currentUser': 'Current identity',
  'exhibitorInfo': 'Exhibitor Information',
  'productList': "Product center",
  'uploadVideoImg': "Video Cover",
  'companybaseMessManageEidt': 'Edit basic information',
  'personDetail': 'Contact us',
  'actorDetail': 'Exhibitor details',
  'productDetail': 'Exhibit details',
  'person': 'Search for visitors',
  'product': 'Search for exhibits',
  'actor': 'Search for exhibitors',
  'popularity': 'Popularity',
  'attention': 'Attention',
  'video': 'Video',
  'spell': 'A-Z',
  'changePass': 'Change personal password',
  'searchList': 'Search list',
  'Booth': 'Booth No',
  'loginTip':'Please login',
  'tip':'Tip'
}
